
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
export default Vue.extend({
  data() {
    return {
      loadingPrebuiltSurveys: false,
      deleteInProgress: false,
      prebuiltSurveysList: [],
      hasLoadedOnce: false,
    };
  },
  methods: {
    async getAllPrebuiltSurveys() {
      try {
        this.loadingPrebuiltSurveys = true;
        const { data } = await FormsAndSurveyServices.getPrebuiltSurveysList({
          locationId: config.prebuiltSurveyLocation,
        });
        this.prebuiltSurveysList = data.themes || data.prebuiltSurveys || [];
        this.hasLoadedOnce = true;
        this.loadingPrebuiltSurveys = false;
      } catch (error) {
        console.log(error);
        this.prebuiltSurveysList = [];
        this.hasLoadedOnce = true;
        this.loadingPrebuiltSurveys = false;
      }
    },
    async deletePrebuiltSurvey(themeId: any) {
      try {
        this.deleteInProgress = true;
        await FormsAndSurveyServices.deleteThemeInSurveys(themeId);
        this.deleteInProgress = false;
        await this.getAllPrebuiltSurveys();
      } catch (error) {
        console.error(error);
        this.deleteInProgress = false;
      }
    },
  },
});
